import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import t from "../button/button.js";
import { createBlock as n, createVNode as r, mergeProps as i, openBlock as a, renderSlot as o, resolveComponent as s, withCtx as c } from "vue";
import { DtIconMoreVertical as l } from "@dialpad/dialtone-icons/vue";
//#region recipes/header/settings_menu_button/settings_menu_button.vue
var u = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeSettingsMenuButton",
	components: {
		DtButton: t,
		DtIconMoreVertical: l
	},
	inheritAttrs: !1,
	props: {
		updateAvailable: {
			type: Boolean,
			default: !1
		},
		ariaLabel: {
			type: String,
			required: !0
		}
	}
};
function d(e, t, l, u, d, f) {
	let p = s("dt-icon-more-vertical"), m = s("dt-button");
	return l.updateAvailable ? (a(), n(m, i({
		key: 0,
		kind: "muted",
		importance: "outlined",
		size: 100,
		class: "d-recipe-settings-menu-button-update",
		"aria-label": l.ariaLabel
	}, e.$attrs), {
		endIcon: c(() => [r(p, { size: "300" })]),
		default: c(() => [o(e.$slots, "default")]),
		_: 3
	}, 16, ["aria-label"])) : (a(), n(m, i({
		key: 1,
		importance: "clear",
		kind: "muted",
		class: "d-recipe-settings-menu-button",
		"aria-label": l.ariaLabel
	}, e.$attrs), {
		icon: c(() => [r(p, { size: "300" })]),
		_: 1
	}, 16, ["aria-label"]));
}
var f = /* @__PURE__ */ e(u, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=settings-menu-button.js.map